export default __webpack_public_path__ + "static/media/logo.b277db98.png";